import ImgFront from '@atoms/ABodyFront';
import { useTypedDispatch } from '@stores/index';
import { Select, Flex, Typography, Space } from 'antd';
import { useEffect, useState } from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { JointsBodyPartMapping } from './ProgramGroup';
import {
	fetchOmniromProgram,
} from '@stores/rom/romTemplates';
import { TOmniromSelectedExercise } from '@stores/interfaces';
import { INTAKE_BODYPOINTS } from '@stores/constants';
import { getJoints } from '@stores/functionalGoals';

const { Title } = Typography;

export interface IBodyPoint {
  setSelectedDropdown: React.Dispatch<React.SetStateAction<string>>;
  selectedDropdown: string;
}


const BodyPage = ({ setSelectedDropdown, selectedDropdown }: IBodyPoint) => {

	const dispatch = useTypedDispatch();
	const [activePart, setActivePart] = useState<string[]>([]);
	const [selectedBodyPointOptions, setSelectedBodyPointOptions] = useState([]);
	const [dropdownOptions, setDropdownOptions] = useState([]);
	const [savedExercise, setSavedExercise] =
		useState<TOmniromSelectedExercise>();

	const handleDropdownChange = async (programId: number | string) => {
		try {
			const response = await dispatch(
				fetchOmniromProgram({ omniRomProgramId: Number(programId) }),
			);
			setSelectedBodyPointOptions(response?.payload[0]?.exercises);
		} catch (error) {
			console.error('Error fetching exercises:', error);
		}
	};

	useEffect(() => {
			fetchingDataforFilters()
		}, [])
	
		const fetchingDataforFilters = async () => {
			const data = await dispatch(getJoints());
			setDropdownOptions(data?.payload?.data)
		};

		const highlightArea = (bodyParts: string | string[]) => {
			const el = document.getElementById('highlght');
			if (el) {
				el.classList.remove('upper', 'right', 'left', 'full', 'lower', 'spine', 'baseline');
			}
		
			const partsArray = Array.isArray(bodyParts) ? bodyParts : [bodyParts];
			const normalizedParts = partsArray.map(p => p.toLowerCase());
		
			setActivePart(normalizedParts);
		
			if (el && normalizedParts.includes('spine')) {
				el.classList.add('spine');
			}
		};
		

		const setActiveHighlight = (part: string) => {
			const lowerCasePart = part.toLowerCase();
			return activePart.includes(lowerCasePart)
				? 'hotspot-circle active'
				: 'hotspot-circle';
		};
		

	const activeStyle = { display: 'inline' };
	const notActiveStyle = { display: 'none' };
	const { t } = useTranslation();


	useEffect(() => {
		if (selectedDropdown && dropdownOptions.length > 0) {
			const selectedExercise = dropdownOptions.find(ex => ex.id === selectedDropdown);
			if (selectedExercise) {
				const bodyParts =
					JointsBodyPartMapping[selectedExercise?.name] || 'full';
				highlightArea(bodyParts);
			}
		}
	}, [selectedDropdown, dropdownOptions]);
	

	return (
		<Flex justify="center" align="center" style={{ height: '100%' }}>
			<Flex vertical style={{ width: '100%', padding: '50px 80px' }}>
				<Title level={2} style={{ color: '#fff', marginBottom: 24 }}>
				{t('Admin.data.intakeProcess.selectBodyRegion')}
				</Title>
				<Select
					className="select-features-dropdown"
					placeholder={t('Admin.data.intakeProcess.selectExercise')}
					options={dropdownOptions?.map((exercise): { label: string; value: string; } => ({
						label: exercise?.name,
						value: exercise?.id,
					}))}
					popupMatchSelectWidth={false}
					allowClear
					value={selectedDropdown || undefined}
					onChange={value => {
						setSelectedDropdown(value);
						handleDropdownChange(value);
						const selectedExercise = dropdownOptions?.find(ex => ex?.id === value);
						if (selectedExercise) {
							setSavedExercise(selectedExercise);
							const bodyParts = JointsBodyPartMapping[selectedExercise?.name] || 'full';
						if (Array.isArray(bodyParts)) {
								bodyParts.forEach(part => highlightArea(part));
							} else {
								highlightArea(bodyParts);
							}
						}
					}}
					
				/>
			</Flex>
			<Space
				align="center"
				className="select-features-program"
				direction="vertical"
				size="middle"
				style={{
					width: '100%',
					height: '100%',
					padding: '100px',
					background: '#00000022',
				}}>
				<div style={{ display: 'inline-block', position: 'relative' }}>
					<div
						className="area-highlight"
						id="highlght"
						style={activePart ? activeStyle : notActiveStyle}></div>
					<ImgFront color="#DCCDE9" width={180} />
					{INTAKE_BODYPOINTS.map((hotspot, index) => (
						<div
							key={index}
							style={hotspot.styles}
							className={setActiveHighlight(hotspot.part.toLowerCase())}></div>
					))}
				</div>
			</Space>
		</Flex>
	);
};

export default BodyPage;
